import * as React from "react";
import { useRef } from "react";
import clsx from "clsx";
import { VideoTypes } from "@bloomberg/media-ui-av";

import { LedeVideoPlaylistPlayer } from "~components/VideoPlayer/LedeVideoPlaylistPlayer";
import { DEFAULT_CONTEXT_OPTIONS } from "~components/VideoPlayer/VideoPlayerContext";
import { VideoPlayerProvider } from "~components/VideoPlayer/VideoPlayerProvider";
import { Video } from "~types/types";

import styles from "./ledeVideo.module.css";

interface LedeVideoProps {
    lede: Video;
    sites: string[];
    className?: string;
}

const LedeVideo = ({ lede, sites, className }: LedeVideoProps) => {
    const videoPlayerContextValue = {
        ...DEFAULT_CONTEXT_OPTIONS,
        autoplay: true,
    };
    const playerRef = useRef<VideoTypes.PlaylistMediaPlayer | null>(null);

    return (
        <div className={clsx(styles.ledeVideo, className)}>
            <VideoPlayerProvider {...videoPlayerContextValue}>
                <LedeVideoPlaylistPlayer
                    video={lede}
                    sites={sites}
                    location="lede"
                    ref={playerRef}
                />
            </VideoPlayerProvider>
        </div>
    );
};

export default LedeVideo;
